import React from 'react';
import PropTypes from 'prop-types';

import { Icon, Tooltip } from '@weezevent/nacre';
import Styles from '../../styles/minisite/blocks.module.css';
import { Trans, useTranslation } from 'react-i18next';
import HTMLReactParser from 'html-react-parser';
import { Loader } from 'semantic-ui-react';

const CTAPlaceholder = () => (
    <div className={Styles['cta-content']}>
        <Icon name="plus" />
        <Trans i18nKey="ticket.event.minisite.block.cta" />
    </div>
);

const EmptyStateCTAContent = ({ hasWidget }) => {
    const { t } = useTranslation();

    if (hasWidget) {
        return <CTAPlaceholder />;
    }

    return (
        <Tooltip triggerOnHover title={t('ticket.event.minisite.block.cta_disabled')} position="top">
            <CTAPlaceholder />
        </Tooltip>
    );
};

const EditActions = ({ onEdit, onDelete, t }) => (
    <span className={Styles['block-editable-delete']}>
        <span className={Styles['block-editable-cta']} onClick={onEdit}>
            <Icon name="edit" /> {t('ticket.common.action.edit')}
        </span>
        <span className={Styles['block-editable-cta']} onClick={onDelete}>
            <Icon name="trash" />
        </span>
    </span>
);

export default function CTABlock({ data, onDelete, onEdit, onClick, blocks }) {
    const [isLoading, setIsLoading] = React.useState(false);
    const { t } = useTranslation();

    const hasWidget = React.useMemo(() => {
        return blocks?.some(block => block.type === 'event-widget');
    }, [blocks]);

    const handleClick = React.useCallback(() => {
        if (!hasWidget) return;
        setIsLoading(true);
        onClick();
    }, [onClick, hasWidget]);

    const isEmpty = data === '' || data === '\n\n';

    return (
        <div
            className={`
                ${Styles['block-editable']} 
                ${Styles['block-cta']} 
                ${isLoading ? Styles['disabled-create-content'] : ''}
                ${!hasWidget ? Styles['block-cta-disabled'] : ''}
            `}
            onClick={isEmpty && hasWidget ? handleClick : null}
        >
            {isLoading && <Loader inline active />}
            {!isEmpty && <EditActions onEdit={onEdit} onDelete={onDelete} t={t} />}

            {isEmpty ? <EmptyStateCTAContent hasWidget={hasWidget} /> : HTMLReactParser(data)}
        </div>
    );
}

CTABlock.propTypes = {
    data: PropTypes.string,
    onDelete: PropTypes.func,
    onEdit: PropTypes.func,
    onClick: PropTypes.func,
    blocks: PropTypes.array
};
